var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var pageResults = require('graph-results-pager');

var ws = require('isomorphic-ws');

var _require = require('subscriptions-transport-ws'),
    SubscriptionClient = _require.SubscriptionClient;

var _require2 = require('graphql-request'),
    request = _require2.request,
    gql = _require2.gql;

var _require3 = require('./../constants'),
    graphAPIEndpoints = _require3.graphAPIEndpoints,
    graphWSEndpoints = _require3.graphWSEndpoints;

var _require4 = require('./../utils'),
    timestampToBlock = _require4.timestampToBlock;

module.exports = {
  user: function user() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, _ref$block, block, _ref$timestamp, timestamp, _ref$user_address, user_address;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$block = _ref.block, block = _ref$block === void 0 ? undefined : _ref$block, _ref$timestamp = _ref.timestamp, timestamp = _ref$timestamp === void 0 ? undefined : _ref$timestamp, _ref$user_address = _ref.user_address, user_address = _ref$user_address === void 0 ? undefined : _ref$user_address;
              _context.t0 = pageResults;
              _context.t1 = graphAPIEndpoints.lockup;
              _context.t2 = {
                where: {
                  address: "\\\"".concat(user_address.toLowerCase(), "\\\"")
                }
              };

              if (!block) {
                _context.next = 8;
                break;
              }

              _context.t3 = {
                number: block
              };
              _context.next = 17;
              break;

            case 8:
              if (!timestamp) {
                _context.next = 15;
                break;
              }

              _context.next = 11;
              return timestampToBlock(timestamp);

            case 11:
              _context.t5 = _context.sent;
              _context.t4 = {
                number: _context.t5
              };
              _context.next = 16;
              break;

            case 15:
              _context.t4 = undefined;

            case 16:
              _context.t3 = _context.t4;

            case 17:
              _context.t6 = _context.t3;
              _context.t7 = _user.properties;
              _context.t8 = {
                entity: 'users',
                selection: _context.t2,
                block: _context.t6,
                properties: _context.t7
              };
              _context.t9 = {
                api: _context.t1,
                query: _context.t8
              };
              return _context.abrupt("return", (0, _context.t0)(_context.t9).then(function (results) {
                return _user.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
var _user = {
  properties: ['id', 'address', 'amount', 'rewardDebt', 'pool { id, balance, accSushiPerShare }', 'sushiAtLockup', 'sushiHarvestedSinceLockup', 'sushiLocked'],
  callback: function callback(results) {
    return results.map(function (entry) {
      return {
        id: entry.id,
        address: entry.address,
        amount: Number(entry.amount),
        rewardDebt: BigInt(entry.rewardDebt),
        pool: {
          id: entry.pool.id,
          balance: Number(entry.pool.balance),
          accSushiPerShare: BigInt(entry.pool.accSushiPerShare)
        },
        sushiAtLockup: Number(entry.sushiAtLockup),
        sushiHarvestedSinceLockup: Number(entry.sushiHarvestedSinceLockup),
        sushiLocked: Number(entry.sushiLocked)
      };
    });
  }
};